'use client';

import React, { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import CountryCode from '../../utils/CountryCode.json';

// Transform country data for react-select
const countryOptions = CountryCode.map(country => {
    // Validate that all required properties exist
    if (!country.dial_code || !country.code || !country.name) {
        console.warn('Invalid country data:', country);
        return null;
    }

    return {
        value: country.dial_code,
        label: `${country.code} ${country.dial_code}`,
        dial_code: country.dial_code,
        code: country.code,
        name: country.name,
    };
}).filter(Boolean); // Remove any null entries

// Custom option component
const CustomOption = props => {
    const { data } = props;
    return (
        <components.Option {...props}>
            <div className="d-flex align-items-center" style={{ fontSize: '12px' }}>
                {/* <div
                    className="me-2 d-flex align-items-center justify-content-center"
                    style={{
                        width: '24px',
                        height: '16px',
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #dee2e6',
                        borderRadius: '2px',
                        fontSize: '10px',
                        fontWeight: 'bold',
                        color: '#495057',
                    }}>
                    {data.code}
                </div> */}
                <span className="me-2">{data.code}</span>
                <span className="text-muted">{data.dial_code}</span>
            </div>
        </components.Option>
    );
};

// Custom single value component (what shows when selected)
const CustomSingleValue = props => {
    const { data } = props;
    return (
        <components.SingleValue {...props}>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    whiteSpace: 'nowrap',
                }}>
                <span style={{ whiteSpace: 'nowrap', fontSize: '12px' }}>{data.dial_code}</span>
            </div>
        </components.SingleValue>
    );
};

// Custom styles for react-select
const customStyles = {
    control: (provided, state) => ({
        ...provided,
        minHeight: '32px',
        height: '32px',
        border: '1px solid #ced4da',
        borderRadius: '4px',
        // boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0,123,255,.25)' : 'none',
        borderColor: state.isFocused ? '#80bdff' : '#ced4da',
        borderBottom: '1px solid var(--Neutral-Gray-6)',
        '&:hover': {
            borderColor: '#80bdff',
        },
    }),
    valueContainer: provided => ({
        ...provided,
        height: '30px',
        padding: '0 8px',
        display: 'flex',
        alignItems: 'center',
    }),
    input: provided => ({
        ...provided,
        margin: '0px',
        padding: '0px',
        height: '30px',
    }),
    indicatorsContainer: provided => ({
        ...provided,
        height: '30px',
    }),
    dropdownIndicator: provided => ({
        ...provided,
        padding: '4px',
    }),
    clearIndicator: provided => ({
        ...provided,
        padding: '4px',
    }),
    menu: (provided, state) => ({
        ...provided,
        zIndex: state.selectProps.insideModal ? 10000002 : 9999,
    }),
    option: (provided, state) => ({
        ...provided,
        padding: '8px 12px',
        backgroundColor: state.isSelected ? '#007bff' : state.isFocused ? '#f8f9fa' : 'white',
        color: state.isSelected ? 'white' : '#495057',
        '&:hover': {
            backgroundColor: state.isSelected ? '#007bff' : '#f8f9fa',
        },
    }),
};

const CountryCodeSelector = ({ value, onChange, placeholder = '...', isDisabled = false, className = '', name = 'code', ariaLabel = 'Country code', insideModal = false }) => {
    const [selectedCountry, setSelectedCountry] = useState(null);

    // Find the country option based on the value prop
    useEffect(() => {
        if (value) {
            const countryOption = countryOptions.find(option => option.value === value);
            setSelectedCountry(countryOption || null);
        } else {
            setSelectedCountry(null);
        }
    }, [value, countryOptions]);

    const handleChange = selectedOption => {
        setSelectedCountry(selectedOption);
        if (onChange) {
            // Pass the dial_code value to maintain compatibility with existing code
            const value = selectedOption ? selectedOption.value : '';
            onChange(value);
        }
    };
    console.log({ selectedCountry });
    return (
        <div className={className}>
            <Select
                key={value || 'empty'} // Force re-render when value changes
                value={selectedCountry}
                onChange={handleChange}
                options={countryOptions}
                components={{
                    Option: CustomOption,
                    SingleValue: CustomSingleValue,
                }}
                styles={{
                    ...customStyles,
                    control: (provided, state) => ({
                        ...customStyles.control(provided, state),
                        height: '32px',
                        minHeight: '32px',
                    }),
                }}
                placeholder={''}
                isDisabled={isDisabled}
                isSearchable={true}
                // isClearable={true}
                isMulti={false}
                menuPortalTarget={insideModal ? null : document.body}
                menuPosition={insideModal ? 'absolute' : 'fixed'}
                insideModal={insideModal}
                name={name}
                aria-label={ariaLabel}
                closeMenuOnSelect={true}
                blurInputOnSelect={true}
                // Remove custom filterOption - let react-select handle filtering automatically
                // The default filter will search through the label property which we set to "code + dial_code"
            />
        </div>
    );
};

export default CountryCodeSelector;
